import { growthInvestmentLinesForDocument, sumGrowthInvestments } from './growthInvestments';

// An invoice's set-off can only ever cover up to the smaller of what's actually owed and
// the Growth Investment requested against it. Several funding months on one invoice are
// summed first — e.g. $100,000 + $80,000 against a $150,000 invoice sets off $150,000.
// A $5,000 invoice against a $3,000 Growth Investment sets off $3,000, leaving $2,000
// owed in cash; a $3,000 invoice against a $5,000 Growth Investment sets off the full
// $3,000, with $2,000 remitted back.
export function totalRequestedGrowthInvestment(invoice) {
  const lines = growthInvestmentLinesForDocument(invoice);
  if (lines.length > 0) {
    return sumGrowthInvestments(lines);
  }
  return Number(invoice?.growthInvestment ?? invoice?.purchaseAmount) || 0;
}

export function getEffectiveSetOffAmount(invoice) {
  const totalRepayment = Number(invoice?.totalDue) || 0;
  return Math.min(totalRepayment, totalRequestedGrowthInvestment(invoice));
}

export function getSetOffNoticeDetails(invoice) {
  const totalRepayment = Number(invoice?.totalDue) || 0;
  const growthInvestmentAmount = totalRequestedGrowthInvestment(invoice);
  const repaymentExceedsGrowthInvestment = totalRepayment > growthInvestmentAmount;
  const netRemittanceAmount = Math.abs(growthInvestmentAmount - totalRepayment);

  return {
    repaymentExceedsGrowthInvestment,
    netRemittanceAmount,
    netRemittanceLabel: repaymentExceedsGrowthInvestment
      ? 'Net amount to be remitted by the Company to Treisar'
      : 'Net amount to be remitted by Treisar to the Company',
  };
}

export function buildSetOffTermsMemo({ requestReceivedDate, repaymentExceedsGrowthInvestment }) {
  const formattedDate = requestReceivedDate || '—';
  const baseText = `This invoice is settled by set-off against the Growth Investment requested by the Company on ${formattedDate}.`;

  if (repaymentExceedsGrowthInvestment) {
    return baseText;
  }

  return `${baseText} No cash payment is required.`;
}
